import { Toast } from 'mint-ui';
export function isPhone(str) {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
    return reg.test(str)
}
export function isWexinmobile(){
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  
  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
      var is_weixin = (function(){return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1})();
      if(is_weixin){
        return true;
      }else{
        return false;
      }
  } else {
    return false;
  }
}
export const toast = (msg) => {
  return Toast({
    message: msg,
    duration: 2000
  });
}

// const base_url = 'http://bookwap.yklmartspace.com/api/home/';
const base_url = 'http://wap.zglcyy.com/api/home/';
// const base_url = '/apis/api/home/';
export const domain =base_url



// WEBPACK FOOTER //
// ./src/utils/utils.js